import { memo } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { HistoryType } from "../../../models";
import { getLocaleStringdDate } from "../../../../../utils/dateFormatt";
import { HistoryItemCreated } from "./HistoryItemCreated";
import { HistoryItemDefault } from "./HistoryItemDefault";
import { HistoryItemDeleted } from "./HistoryItemDeleted";
import { HistoryItemInformationRequested } from "./HistoryItemInformationRequested";
import { HistoryItemDocumentChangeGroup } from "./HistoryItemDocumentChangeGroup";
import { HistoryItemRiskLevelChanged } from "./HistoryItemRiskLevelChanged";
import { HistoryItemStatusChanged } from "./HistoryItemStatusChanged";
import { HistoryItemStatusReasonChanged } from "./HistoryItemStatusReasonChanged";
import {
  DateGrid,
  HistoryDisplayItemProps,
  HistoryGrid,
} from "./common";
import { isHistoryDocumentChangeGroup } from "../../../utils/historyDisplay";

export const HistoryItemInfo = ({
  item,
  statusesConfig,
  verificationRequestId,
}: HistoryDisplayItemProps) => {
  if (isHistoryDocumentChangeGroup(item)) {
    return (
      <HistoryItemDocumentChangeGroup
        item={item}
        statusesConfig={statusesConfig}
        verificationRequestId={verificationRequestId}
      />
    );
  }

  switch (item.type) {
    case HistoryType.HISTORY_TYPE_CREATED:
      return <HistoryItemCreated item={item} statusesConfig={statusesConfig} />;

    case HistoryType.HISTORY_TYPE_DELETED:
      return <HistoryItemDeleted item={item} statusesConfig={statusesConfig} />;

    case HistoryType.HISTORY_TYPE_STATUS_CHANGED:
      return (
        <HistoryItemStatusChanged item={item} statusesConfig={statusesConfig} />
      );

    case HistoryType.HISTORY_TYPE_RISK_LEVEL_CHANGED:
      return (
        <HistoryItemRiskLevelChanged
          item={item}
          statusesConfig={statusesConfig}
        />
      );

    case HistoryType.HISTORY_TYPE_INFORMATION_REQUESTED:
      return (
        <HistoryItemInformationRequested
          item={item}
          statusesConfig={statusesConfig}
        />
      );

    case HistoryType.HISTORY_TYPE_STATUS_REASON_CHANGED:
      return (
        <HistoryItemStatusReasonChanged
          item={item}
          statusesConfig={statusesConfig}
        />
      );

    default:
      return <HistoryItemDefault item={item} statusesConfig={statusesConfig} />;
  }
};

export const HistoryItem = memo(
  ({ item, statusesConfig, verificationRequestId }: HistoryDisplayItemProps) => {
    return (
      <HistoryGrid container wrap="nowrap">
        <Grid container item>
          <HistoryItemInfo
            item={item}
            statusesConfig={statusesConfig}
            verificationRequestId={verificationRequestId}
          />
        </Grid>
        <DateGrid container item>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
            }}
          >
            {getLocaleStringdDate(item.createdAt)}
          </Typography>
        </DateGrid>
      </HistoryGrid>
    );
  }
);
